import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import slide1 from "../../../assets/images/banner1.webp";
import slide2 from "../../../assets/images/banner2.webp";
import slide3 from "../../../assets/images/banner3.webp";
import sidebanner from "../../../assets/images/sidebanner.webp";
import sidebanner1 from "../../../assets/images/sidebanner1.webp";
import { useNavigate } from "react-router-dom";

const BannerSection = () => {
  let navigate = useNavigate();
  return(

  <div className="banner">
    <div className="container py-2">
      <div className="row">
        <div className="col-md-8">
          <div style={{ padding: "0 10px" }}>
            <Swiper
              modules={[EffectFade, Autoplay]}
              effect="fade"
              autoplay={{ delay: 2000, disableOnInteraction: false }}
              loop={true}
              style={{ height: "100%" }}
            >
              <SwiperSlide>
                <img
                  src={slide1}
                  alt="slide1"
                  style={{ width: "100%", objectFit: "cover" }}
                  onClick={()=>navigate("/shop")}
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={slide2}
                  alt="slide2"
                  style={{ width: "100%", objectFit: "cover" }}
                  onClick={()=>navigate("/shop")}
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={slide3}
                  alt="slide3"
                  style={{ width: "100%", objectFit: "cover" }}
                  onClick={()=>navigate("/shop")}
                />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
        <div className="col-md-4">
          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              padding: "0 10px",
            }}
          >
            <img
              src={sidebanner}
              alt="slide1"
              style={{ width: "100%", objectFit: "cover" }}
              onClick={()=>navigate("/shop")}
            />
            <img
              src={sidebanner1}
              alt="slide2"
              style={{ width: "100%", objectFit: "cover" }}
              onClick={()=> window.open('https://wa.me/919884455605', "_blank")}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);
}
export default BannerSection;
